export const globalStoreConfig = { noneUserRelated: true };
